/**
 * Created by vladislav on 18/05/2023
 */

const GameLevelConfig = {};

(function () {
    const GameLevelConfigData = { 
        main: {
            calcThreshold: function () {
                const threshold = [
                    20, 30, 40, 50, 50, 60, 60, 70, 70, 70,
                    80, 80, 80, 90, 90, 90, 100, 100, 100, 100,
                    110, 110, 110, 110, 120, 120, 120, 120,
                    130, 130, 130, 130, 130, 140, 140, 140, 140,
                    150
                ];
                const delta = 10;
                for (let i = threshold.length; i < 100; i++) {
                    threshold.push(threshold[i - 1] + delta);
                }

                return threshold;
            },
            calcReward: function (level) {
                const rewards = bundles.level_rewards.jsons.level_rewards_json.resolve().getJson();

                if (rewards[level]) {
                    return rewards[level];
                }

                const tailSize = Math.min(10, rewards.length);
                const tailStart = rewards.length - tailSize;
                return rewards[tailStart + ((level - tailStart) % tailSize)];
            }
        }
    };

    for (const id in GameLevelConfigData) {
        GameLevelConfig[id] = {
            threshold: GameLevelConfigData[id].calcThreshold(),
            calcReward: GameLevelConfigData[id].calcReward
        };
    }
}());
